import { DisputeDetail, DisputeSummary, InvoiceDetail, InvoiceSummary, PaymentDetail, PaymentSummary } from 'types';

export const convertDispute = ({ submittedDateUtc, updatedDateUtc, invoiceDetailLines, paymentDetailLines, accountId, vendorId, ...rest }: DisputeDetail) => ({
    ...rest,
    accountId,
    vendorId,
    submittedDateUtc:  new Date(submittedDateUtc),
    updatedDateUtc: updatedDateUtc ? new Date(updatedDateUtc) : undefined,
    invoiceDetailLines: invoiceDetailLines ? convertInvoiceDetails(invoiceDetailLines).map(line => ({ ...line, accountId, vendorId })) : undefined,
    paymentDetailLines: paymentDetailLines ? convertPaymentDetails(paymentDetailLines).map(line => ({ ...line, accountId, vendorId })) : undefined
}) as DisputeDetail;

export const convertDisputeSummaries = (data: DisputeSummary[]) => data.map(({ submittedDateUtc, updatedDateUtc, ...rest }) => ({
    ...rest,
    submittedDateUtc: new Date(submittedDateUtc),
    updatedDateUtc: updatedDateUtc ? new Date(updatedDateUtc) : undefined
}));

export const convertInvoiceDetails = (data: InvoiceDetail[]) => data.map(({ lastUpdated, rowNumber, ...details }, index) => ({
    ...details,
    rowNumber: rowNumber ?? index + 1,
    lastUpdated: lastUpdated ? new Date(lastUpdated) : undefined
}));

export const convertInvoiceSummaries = (data: InvoiceSummary[]) => data.map((invoice) => {
    const { invoiceDate, paymentDate, scheduledPayDate } = invoice;
    return {
        ...invoice,
        invoiceDate: invoiceDate ? new Date(invoiceDate) : undefined,
        paymentDate: paymentDate ? new Date(paymentDate) : undefined,
        scheduledPayDate: scheduledPayDate ? new Date(scheduledPayDate) : undefined
   };
});

export const convertPaymentDetail = (data: PaymentDetail, index: number = 0) => {
    const { invoiceDate, paymentDate, scheduledPayDate, rowNumber } = data;

    return {
        ...data,
        rowNumber: rowNumber ?? index + 1,
        invoiceDate: invoiceDate ? new Date(invoiceDate) : undefined,
        paymentDate: paymentDate ? new Date(paymentDate) : undefined,
        scheduledPayDate: scheduledPayDate ? new Date(scheduledPayDate) : undefined,
    };
};

export const convertPaymentDetails = (data: PaymentDetail[]) => data.map((paymentDetail, index) => convertPaymentDetail(paymentDetail, index));

export const convertPaymentSummaries = (data: PaymentSummary[]) => data.map((payment) => {
    const { paymentDate, scheduledPayDate } = payment;
    return {
        ...payment,
        paymentDate: paymentDate ? new Date(paymentDate) : undefined,
        scheduledPayDate: scheduledPayDate ? new Date(scheduledPayDate) : undefined
    };
});